/**
 * Mirrors the `public.services` column widths enforced by the portal API.
 * `CMS_KEY` has no column of its own — it lives in the `metadata` jsonb, so the
 * limit is an arbitrary cap to keep SKUs manageable.
 */
export const CHARACTER_LIMITS = {
  SERVICE_NAME: 256,
  DISPLAY_NAME: 1000,
  DESCRIPTION: 1000,
  MAIN_URL: 1000,
  ICON_KEY: 100,
  CMS_KEY: 64,
};

export const COLORS = {
  body: '#333',
  muted: '#777',
  border: '#e0e0e0',
  primary: '#0e7c86',
  primaryLight: '#e6f4f5',
  bgPage: '#f5f7fa',
  cardBg: '#fff',
};
